module.exports = __webpack_public_path__ + "img/cooperate_zf_04@2x.ae3f6211.png";